import React, { useCallback, forwardRef } from 'react'
import { useDispatch } from 'react-redux'

import PropTypes from 'prop-types'

import toLower from 'lodash/toLower'

import { reloadSchema } from '@galo-monitor/forms'
import changePasswordSchema from '@galo-monitor/forms/schemas/common/changePassword.schema'
import { useT } from '@galo-monitor/i18n'
import { useSnackbar } from '@galo-monitor/snackbar'
import { AuthenticationActions } from '@galo-monitor/stores/authentication'
import { UserActions } from '@galo-monitor/stores/user'
import Form from '@galo-monitor/web-components/Form'
import InputPassword from '@galo-monitor/web-components/InputPassword'

import { Container } from './theme'

const ResetPasswordForm = forwardRef((props, formRef) => {
  const { loading, setLoading, onSuccess, onError } = props

  const dispatch = useCallback(useDispatch(), [])
  const t = useT()
  const snackbar = useSnackbar()


  const validateSamePassword = useCallback(
    () => reloadSchema(formRef, true),
    [formRef]
  )

  const handleError = useCallback(
    (data) => {
      onError(data, false)
      formRef.current.setFieldValue('password_old', '')
    },
    [formRef, onError]
  )

  const handleSubmit = useCallback(
    (data) => {
      setLoading(true)
      dispatch(UserActions.updateUserPassword(
        data,
        () => {
          snackbar.success(t('{this} {action} successfully!', {
            this: toLower(t('password', { howMany: 1 })),
            action: toLower(t('updated', { gender: 'female', howMany: 1 }))
          }))
          onSuccess()
          dispatch(AuthenticationActions.resetAuthentication())
        },
        handleError
      ))
    },
    [dispatch, handleError, onSuccess, setLoading, snackbar, t]
  )

  return (
    <Form
      ref={ formRef }
      schemaConstructor={ changePasswordSchema }
      onSubmit={ handleSubmit }
    >
      <Container>
        <InputPassword
          name="password_old"
          label={ t('current password') }
          disabled={ loading }
          fullWidth
        />

        <InputPassword
          name="password"
          label={ t('new password') }
          disabled={ loading }
          onChange={ validateSamePassword }
          fullWidth
        />

        <InputPassword
          name="password_confirmation"
          label={ t('repeat new password') }
          disabled={ loading }
          onChange={ validateSamePassword }
          fullWidth
        />
      </Container>
    </Form>
  )
})

ResetPasswordForm.propTypes = {
  loading: PropTypes.bool,
  setLoading: PropTypes.func,
  onSuccess: PropTypes.func,
  onError: PropTypes.func
}

ResetPasswordForm.defaultProps = {
  loading: false,
  setLoading: () => {},
  onSuccess: () => {},
  onError: () => {}
}

export default ResetPasswordForm
